import { rem, color, radius } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = css`
  :host {
    --height: ${rem(36)};

    display: block;
    inline-size: 100%;
  }

  :host([fixedWidth]) {
    inline-size: ${rem(288)};
    --height: ${rem(32)};
  }

  :where(.placeholder-container) {
    background-color: ${color('grey', 600)};
    block-size: var(--height);
    display: flex;
  }

  :where(.placeholder-button) {
    block-size: 100%;
    inline-size: ${rem(36)};
  }

  :where(.placeholder-progress) {
    align-items: center;
    display: flex;
    inline-size: calc(100% - ${rem(36)});
    justify-content: center;
  }

  :where(.placeholder-progress-bar) {
    background-color: ${color('grey', 500)};
    block-size: ${rem(4)};
    border-radius: ${radius('small')};
    inline-size: 80%;
  }

  /* We can't use CSS @layer's to overwrite the Bluebillywig CSS */
  /* so we're forced to resort to ugly !important's. */
  /* stylelint-disable declaration-no-important */
  .bbv {
    overflow: visible !important;
  }

  .bb_iawr {
    block-size: var(--height) !important;
    overflow: visible !important;
  }

  .bb_wrapper {
    block-size: var(--height) !important;
  }

  .bb-content-layer,
  .bb-context-layer,
  .bb-poster-layer {
    display: none;
  }

  .bb-layer {
    overflow: visible !important;
  }

  .bbv-zoom {
    display: none !important;
  }

  .bbv-auto-replay {
    display: none !important;
  }
`;
